import type { UserInstrumentDto } from "@eu.mdotm.api/sphere";
import type { Map as ImmutableMap } from "immutable";

/**
 * Returns the tag-classification label for a given instrument and groupBy dimension.
 * classificationUuid is from userClassificationsMap$ (fieldType === "TAG").
 */
export function classOf(
	tickerName: string,
	instrumentPool: ImmutableMap<string, UserInstrumentDto>,
	classificationUuid: string,
): string {
	const instrument = instrumentPool.get(tickerName);
	if (!instrument) {
		return "Ungrouped";
	}
	const tag = instrument.tags?.find((t) => t.classificationUuid === classificationUuid);
	return tag?.values?.[0]?.option ?? "Ungrouped";
}
